import KeyValuePair from '@/modules/core/support/KeyValuePair'
import {AxiosError} from "axios";
import _ from 'lodash'

export default class PrintResult {
    public content = ''
    public contentType = ''
    public failed = false
    public reason = ''

    public static deserialize (data: KeyValuePair) {
        const result = new this()
        result.content = data.content || ''
        result.contentType = data.content_type || ''
        result.reason = data.reason || ''
        result.failed = !data.success || false

        return result
    }

    public static fromError(error: AxiosError) {
        const result = new this()
        result.failed = true
        result.reason = _.get(error, 'response.data.message', error.message)

        return result
    }
}
